<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- EDITAR-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-body">
          <div class="row">
            <!-- INSTRUÇÕES -->
            <div class="col-sm-12">
              <div class="form-group">
                <span style="color: red">Instruções: Imagem 400x250 e Fundo branco ou transparente</span>
              </div>
            </div>

            <!-- NOME -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputEmail1">Nome</label>
                <input class="form-control" id="nome" placeholder="Nome" v-model="formData.nome" />

                <span style="color: red" v-for="error in v$.nome.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ARQUIVO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputFile">Arquivo</label>
                <input class="form-control" type="file" @change="onChange" />
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="sendFileS3()">Salvar</button>
          <a type="submit" href="/admin/logos" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["logo"],

  components: { Loading },

  data() {
    return {
      nome: "",
      isLoading: false,
      upload_files: "",
    };
  },

  setup() {
    const formData = reactive({
      nome: "",
    });

    const rules = computed(() => {
      return {
        nome: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.formData.nome = this.logo.nome;
  },

  methods: {
    onChange(e) {
      this.upload_files = e.target.files[0];
    },

    async sendFileS3() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        if (this.upload_files) {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("id", "1");
            formData.append("path", "rochaleiloes2/logos/");
            formData.append("file", this.upload_files);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
              .then((response) => {
                console.log("ENVIANDO PARA O BANCO\n");

                this.update(response.data.key);
              })
              .catch((error) => {
                console.log(error);

                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response.data.error);
                console.log(error);
                reject();
              });
          });
        } else {
          this.update(null);
        }
      }
    },

    async update(file) {
      this.isLoading = true;

      console.log(file);

      let fd = new FormData();
      fd.append("nome", this.formData.nome);
      fd.append("path", "rochaleiloes2/logos");
      fd.append("id", this.logo.id);

      if (this.upload_files) {
        let fileName = file.split("/");
        fd.append("file", fileName[fileName.length - 1]);
      }

      console.log("Cadastrando");
      console.log(fd);

      axios
        .post(`/admin/logo/update`, fd)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButton("Sucesso", "Dados editados");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },
  },
};
</script>
